module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_an_black-6603d4986a0953ed6072369cf2bcdce8.svg";